<template>
    <div id="departments">
        <div style="height: 6px;"></div>
        <div style="padding: 6px;"> </div>
        <div v-show="showButton">
            <el-button class="btn btn1" icon="el-icon-circle-plus-outline" @click="searchUserGroup = true"
                :disabled="!addTableListPriv" :class="!addTableListPriv ? 'btnDisable' : ''">{{ $t('message.button.add') }}
            </el-button>
            <el-button class="btn btn2" icon="el-icon-delete" @click="removeCheckbox" :disabled='!removeBtnPriv'
                :class="!removeBtnPriv ? 'btnDisable' : ''">{{ $t('message.button.delete') }}
            </el-button>
            <el-button class="btn btn3" icon="el-icon-document-checked" @click="getUpdateEvent" v-if="!editShow"
                :disabled="!workFlowStatus" :class="!workFlowStatus ? 'btnDisable' : ''">{{ $t('message.button.save')
                }}</el-button>
            <el-button class="btn btn4" icon="el-icon-circle-close" @click="closeSave" v-if="!editShow"
                :disabled="!workFlowStatus" :class="!workFlowStatus ? 'btnDisable' : ''">{{ $t('message.button.cancel')
                }}</el-button>
        </div>

        <el-dialog class="searchAddBomList" v-if='searchUserGroup' :title="$t('message.title.add')"
            :visible.sync="searchUserGroup">
            <SearchResource @listDbClick="addList"></SearchResource>
        </el-dialog>
        <div style="padding: 10px 20px;">
            <!-- 表格区域 -->
            <vxe-grid ref='xGrid' v-bind="gridOptions" @checkbox-change="checkboxChangeEvent"
                @checkbox-all="checkboxChangeEvent"
                @cell-dblclick="noEdit">
                <template #bottom>
                    <div class="alert-message">
                        <span class="alert-message-content">
                            <div>{{ $t('message.title.Checked') + selectRecords.length + $t('message.title.resultsNums') }}
                                {{ $t('message.title.totalResults') + totalRecords + $t('message.title.resultsNums') }}
                            </div>
                        </span>
                    </div>
                </template>
            </vxe-grid>
        </div>

    </div>
</template>
  
<style></style>
  
<script>

import axios from "axios";
import SearchResource from '@/components/searchResource.vue';
export default {
    data() {
        return {
            showButton:true,
            queryMap: "",

            selectRecords: [],
            totalRecords: "",
            searchUserGroup: false,
            gridOptions: {
                keepSource: true,
                resizable: true,
                border: true,
                stripe: true,
                highlightHoverRow: true,
                highlightCurrentRow: true,
                showHeaderOverflow: true,
                showOverflow: true,
                rowId: 'id',
                height: "450",
                size: "small",
                data: [],
                editConfig: {
                    trigger: 'dblclick',
                    mode: 'cell',
                    showIcon: false,
                    activeMethod: this.activeRowMethod,
                    showStatus: true,
                },
                sortConfig: {
                    trigger: 'cell'
                },
            },

            editShow: false,
            workFlowStatus: true,//变更工作流状态
            loading: true,
            cols: [], //表头
            rols: [], //表体所有内容
            rols_text: [], //表体显示内容
            get_change_info: "", //父组件传来的值

            //权限
            removeBtnPriv: false,
            addTableListPriv: false,
            cascaderShow: false,
            cascaderValue: [],
            cascaderList: [],
            cascaderProps: {}
        }
    },
    components: {
        SearchResource,
    },
    mounted() { },

    methods: {
        //跳转
        showDetailEvent(row) {
            console.log(row);
            const obj = {
                id: row.itemId,
                classId: row.itemClassId,
                subClassId: row.itemSubClassId,
                title: row[0]
            };
            this.getLink(obj);
            this.$store.commit("setPageRefresh");
        },
        checkboxChangeEvent({ records }) {
            const $grid = this.$refs.xGrid;
            this.selectRecords = records;
        },

        addList(row) { //添加
            let arr = []
            for (let i = 0; i < this.gridOptions.data.length; i++) {
                const e = this.gridOptions.data[i];
                arr.push(e.itemId)
            }
            if (arr.indexOf(row.id) === -1) {
                let arr = [];
                let insertUserGroups = {};
                insertUserGroups.id = row.id;
                insertUserGroups.classId = row.classId;
                arr.push(insertUserGroups);
                let obj = { ...this.$store.state.objectId };
                let myMap = {};
                let arrResource = row.map(i => {
                    return {
                        parentId: this.$store.state.objectId.classId == 50201?i.itemId:this.$store.state.objectId.id,
                        childId: this.$store.state.objectId.classId == 50201?this.$store.state.objectId.id:i.itemId,
                        notes: "",
                    };
                });
                myMap.relatedResource = arrResource;
                axios.post('/pmdm/resource/saveResourceRelation',myMap)
                    .then(res => {
                        console.log(res);
                        if (res.data.code == 200) {
                            this.$message({
                                message: res.data.message,
                                type: 'success'
                            });
                            this.getUserGroup();
                        }
                    })
                    .catch();
            } else {
                this.$message.error(this.$t('message.error.sameUser'));
            }
        },
        removeCheckbox(grid) { //删除
            let obj = {}
            obj.id = this.$store.state.objectId.id + '';
            obj.classId = this.$store.state.objectId.classId + '';
            obj.subClassId = this.$store.state.objectId.subClassId + '';
            console.log(this.$refs.xGrid);
            var removeRow = this.$refs.xGrid.getCheckboxRecords();
            console.log(removeRow);
            var del_table = [];
            var vm = this;
            if (removeRow.length == 0) {
                return false
            } else {
                for (let i = 0; i < removeRow.length; i++) {
                    const e = removeRow[i];
                    del_table.push(
                        e.rowId,
                    );
                };
                const str = JSON.stringify(del_table);
                const result = str.replace(/\[|\]/g, '');
                var userGroupList = {
                    ids: result
                };
                axios.post('/pmdm/resource/delResourceRelation', userGroupList).then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        //console.log(res);
                        this.getUserGroup();
                        this.selectRecords = [];

                    }
                })
                    .catch(function (error) {
                        console.log(error);
                    });
            }

        },
        getUpdateEvent() {
            var xGrid_ = this.$refs.xGrid;
            var columns = this.gridOptions.columns;
            var cols_ = this.cols;
            let updateRecords = xGrid_.getUpdateRecords(); //获取修改的行;
            var cols_length = cols_;
            var updateRel = [];
            if (updateRecords.length !== 0) {//判断行内那些值有改动
                for (let i = 0; i < updateRecords.length; i++) {
                    var num = xGrid_.getRowIndex(updateRecords[i]);
                    for (let j = 0; j < cols_length.length; j++) {
                        var updateNewData = xGrid_.isUpdateByRow(updateRecords[i], "" + j);
                        if (updateNewData) {
                            for (let k = 0; k < columns.length; k++) {
                                var obj = {};
                                if (cols_length[j] == columns[k].attid) {
                                    var quantity = cols_length[j];
                                    obj.id = updateRecords[i].rowId;
                                    if (columns[k].editRender.props) {//处理多选和单选
                                        if (columns[k].editRender.props.multiple) {
                                            obj[quantity] = updateRecords[i][j].join(";")
                                        } else if (columns[k].editRender.props.type == "datetime") {
                                            obj[quantity] = this.format(updateRecords[i][j], "yyyy-MM-ddThh:mm:ss");
                                        } else {
                                            if (updateRecords[i][j] == null) {
                                                obj[quantity] = "";
                                            } else {
                                                obj[quantity] = updateRecords[i][j];
                                            }
                                        }
                                    } else {
                                        if (updateRecords[i][j] == null) {
                                            obj[quantity] = "";
                                        } else {
                                            obj[quantity] = updateRecords[i][j];
                                        }
                                    };
                                    console.log(obj);
                                    updateRel.push(obj);
                                }
                            }
                        }
                    }
                };
                let myMap = {};
                let arrResource = this.ArrayFilter(updateRel).map(i => {
                    return {
                        id: i.id,
                        notes: i[5021010],
                    };
                });
                myMap.relatedResource = arrResource;
                axios.post('/pmdm/resource/updateResourceRelation', myMap)
                    .then(res => {
                        if (res.data.code == 200) {
                            this.$message({
                                message: res.data.message,
                                type: 'success'
                            });
                            this.getUserGroup();
                        }
                    })
                    .catch(function (error) {
                    });
            };
        },
        ArrayFilter(l) {
            let arr = l
            console.log(l);
            let list = arr.reduce((pre, cur) => {
                let target = pre.find(ee => ee.id == cur.id)
                if (target) {
                    Object.assign(target, cur)
                } else {
                    pre.push(cur)
                }
                return pre
            }, [])
            return list
        },
        closeSave() {
            this.$refs.xGrid.revertData(); //清除所有保存，删除，添加记录
        },
        noEdit({ row, column, columnIndex }) {
            if (column.editRender.cascaderType && this.editTable) {
                this.cascaderList = column.editRender.cascadeOptions;
                let m = row[[column.property]];
                if (column.editRender.props.multiple) {
                    this.cascaderValue = m ? m.map((i) => { return this.getParentIdList(this.cascaderList, i) }) : ''
                    this.cascaderProps.multiple = true;
                } else {
                    this.cascaderProps.multiple = false;
                    this.cascaderValue = m;
                }
                this.cascaderProps.checkStrictly = true;
                this.tempData = { row, column }
                this.cascaderShow = true;
            }
        },
        activeRowMethod({ row }) {
            return !row.disable
        },
        async getUserGroup() {
            this.$emit('refreshTab');
            var change_info = this.$store.state.change_info;
            if (this.get_change_info == "") {
                change_info = this.$store.state.change_info;
            } else {
                change_info = this.get_change_info;
            };

            var obj_get = { //获取change
                ... this.$store.state.objectId,
                tableId: 33
            };
            var loadTableUrl = `/pmdm/resource/loadTable${this.params(obj_get)}`;
            const { //获取标题
                data: res
            } = await this.$http.get(loadTableUrl);
            this.gridOptions.columns = this.getNewTableTitleData(res);
            this.cols = res.object.table.columnInfo.ids;
            this.rols_text = this.getNewTableContentData(res);
            this.gridOptions.data = this.rols_text;
            this.totalRecords = res.object.table.rows?res.object.table.rows.length:res.object.table.totalRecords;
            this.$refs.xGrid.loadData(this.rols_text);
            this.selectRecords = [];
        },
        loadUserPriv() {
            var priv_ = this.getUserContextPriv();
            let subClass_Id = this.$store.state.objectId.subClassId;
            for (let i = 0; i < priv_.length; i++) {
                if (priv_[i].classId == subClass_Id) {
                    if (priv_[i].type == 3) {
                        this.addTableListPriv = true;
                    };
                    if (priv_[i].type == 4) {
                        this.removeBtnPriv = true;
                    }
                }
            }
            if (this.$store.state.objectId.classId !== 50202) {
                this.showButton = false;
            }
        },
    },
    created() {
        this.getUserGroup();
        this.loadUserPriv();
        setTimeout(() => {
            this.loading = false;
        }, 500);
    },

};
</script>